import { DataGrid } from "devextreme-react";
import { Column, ColumnChooser, Grouping, GroupPanel, Pager, Paging, SearchPanel } from "devextreme-react/data-grid";
import { IDepositLoanTransactionRecordDto } from "../../../dtos/transactions/IDepositLoanTransactionRecordDto";

interface IProps {
  items: IDepositLoanTransactionRecordDto[];
}

export const DepositLoanTransactionRecordTable = ({ items }: IProps) => {
  const pageSizes = [10, 25, 50, 100];

  return (
    <>
      <div className={"overflow-auto"}>
        <DataGrid
          dataSource={items}
          sorting={{ mode: "multiple" }}
          allowColumnReordering={true}
          rowAlternationEnabled={false}
          showBorders={false}
          showRowLines={true}
          allowColumnResizing={true}
          selection={{ mode: "single" }}
          loadPanel={{ enabled: true, showIndicator: true, showPane: false }}
        >
          <ColumnChooser enabled={true} />
          <GroupPanel visible={true} />
          <SearchPanel visible={true} highlightCaseSensitive={true} />
          <Grouping autoExpandAll={false} />

          <Column width={150} dataField="period" dataType={"datetime"} caption="Period" sortOrder={"asc"} sortIndex={1} />
          <Column width={150} dataField="documentId" dataType={"string"} caption="Document " />
          <Column width={150} dataField="movementType" dataType={"number"} caption="Movement Type" />
          <Column width={150} dataField="contractId" dataType={"string"} caption="Contract" />
          <Column width={150} dataField="amount" dataType={"number"} caption="Amount" />
          <Column width={150} dataField="currencyId" dataType={"string"} caption="Currency" />
          <Column width={150} dataField="companyId" dataType={"string"} caption="Company" />
          <Column width={150} dataField="partnerId" dataType={"string"} caption="Partner" />
          <Column width={150} dataField="counterpartyId" dataType={"string"} caption="Counterparty" />
          <Column width={150} dataField="senderBankAccountId" dataType={"string"} caption="Sender Bank Account" />
          <Column width={150} dataField="receiverPayerBankAccountId" dataType={"string"} caption="Receiver Payer Bank Account" />
          <Column width={150} dataField="payerAccountId" dataType={"string"} caption="Payer Account" />
          <Column width={150} dataField="description" dataType={"string"} caption="Description" />
          <Column width={150} dataField="recorder" dataType={"string"} caption="Recorder" />
          <Column width={150} dataField="lineOfBusiness" dataType={"string"} caption="Line Of Business" />
          <Column width={150} dataField="paymentMethod" dataType={"string"} caption="Payment Method" />
          <Column width={150} dataField="recordDate" dataType={"datetime"} caption="Record Date" />
          <Column width={150} dataField="paymentDate" dataType={"datetime"} caption="Payment Date" />
          <Column width={150} dataField="beingPaid" dataType={"number"} caption="Being Paid" />
          <Column width={150} dataField="company2Name" dataType={"string"} caption="Company 2 Name" />
          <Column width={150} dataField="company2Id" dataType={"string"} caption="Company 2 Id" />
          <Column width={150} dataField="documentName" dataType={"string"} caption="Document Name" />
          <Column width={150} dataField="currencyName" dataType={"string"} caption="Currency Name" />
          <Column width={150} dataField="contractName" dataType={"string"} caption="Contract Name" />
          <Column width={150} dataField="partnerName" dataType={"string"} caption="Partner Name" />
          <Column width={150} dataField="counterpartyName" dataType={"string"} caption="Counterparty Name" />
          <Paging defaultPageSize={10} />
        </DataGrid>
      </div>
    </>
  );
};
